var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1.Bace\u57FA\u7840/3.Icon\u56FE\u6807/\u5176\u4ED6/server") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u89C4\\u8303/\\u5207\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8861\\u6CF0\\u4FE1\\u4F1A\\u6240\\u89C4\\u83032",
    transform: "translate(-192.000000, -1384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(110.000000, 684.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(0.000000, 668.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.Bace\\u57FA\\u7840/3.Icon\\u56FE\\u6807/\\u5176\\u4ED6/server",
    transform: "translate(82.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L20,0 L20,20 L0,20 L0,0 Z",
    id: "\\u77E9\\u5F62",
    opacity: 0.0000999999975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5859149,0.963275898 C10.2233355,0.753940586 9.77661919,0.753940586 9.41403985,0.963275898 L2.38098907,5.02380967 C2.071588,5.20244246 1.88098907,5.53256948 1.88098907,5.88983507 L1.88098907,14.0109026 L1.88098907,14.0109026 C1.88098907,14.4295733 2.1043472,14.8164413 2.46692657,15.0257766 L9.49997744,19.0863095 C9.80937847,19.2649422 10.1905762,19.2649422 10.4999773,19.0863095 L17.5330281,15.0257766 L17.5330281,15.0257766 C17.8956075,14.8164413 18.1189656,14.4295733 18.1189656,14.0109026 L18.1189656,5.88983507 C18.1189656,5.53256948 17.9283667,5.20244246 17.6189656,5.02380967 L10.5859149,0.963275898 L10.5859149,0.963275898 Z M3.75512362,5.67281961 L9.99997735,2.06748471 L16.2441206,5.67306578 L9.99872684,9.27748501 L3.75512362,5.67281961 Z M16.8687284,6.75599754 L16.8687284,13.9649856 L10.6249774,17.5692022 L10.6249774,10.3608286 L16.8687284,6.75599754 Z M3.12997721,6.75527632 L3.12997721,13.9649856 L9.37497735,17.5692677 L9.37497735,10.3608286 L3.12997721,6.75527632 Z",
    id: "control-platform",
    fillOpacity: 0.9,
    fill: "currentColor"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.ecea9c2a2bfff8b8dd5786ce2e146f3a.svg";
export { ForwardRef as ReactComponent };